import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { DynamicForm, SubmitBtn, Copyright, Info } from '../../components';
import { useRoutes, useBlockNavigation, useApi } from '../../hooks/';
import { setAuth } from '../../store';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(5),
  },
  resetPassword: {
    marginTop: theme.spacing(3),
  },
  action: {
    flex: 1,
  },
  secondBtn: {
    width: `100%`,
    marginTop: theme.spacing(3),
  },
  info: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(5),
  },
}));

export const Login: React.FC = () => {
  const { paths, navigate } = useRoutes();
  useBlockNavigation({ isLoggedIn: true, navigateTo: paths.asct.path });
  const classes = useStyles();
  const dispatch = useDispatch();
  const url = localStorage.getItem('path')
  const navigateToAsct =url?navigate(url): navigate(paths.asct.path);
  const navigateToResetPassword = navigate(paths.resetPassword.path);
  const navigateToForgetPassword = navigate(paths.forgetPassword.path);
  const { login } = useApi();
  const [error, setError] = useState('');

  const handleOnSubmit = useCallback(
    async ({ username, password }) => {
      try {
        const response = await login(username, password);
        if (!response.token) {
          throw new Error();
        }
        dispatch(setAuth(response));
        if (response.isTemporary) {
          return navigateToResetPassword();
        }
        return navigateToAsct();
      } catch (error) {
        setError('auth/wrong-credentials');
      }
    },
    [navigateToResetPassword, navigateToAsct, setError, dispatch, login]
  );

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="sm" className={classes.container}>
        <Typography variant="h4" component="h4" align="center">
          Connexion
        </Typography>
        <DynamicForm
          fields={{
            username: {
              label: 'Identifiant (numéro de CP)',
              initialValue: '',
              type: 'text',
            },
            password: {
              label: 'Mot de passe',
              initialValue: '',
              type: 'password',
            },
          }}
          validationSchema={Yup.object({
            username: Yup.string().required('Ce champ est requis'),
            password: Yup.string().required('Ce champ est requis'),
          })}
          error={error}
          onSubmit={handleOnSubmit}
        >
          {(form: any) => (
            <SubmitBtn
              color="primary"
              title="Connexion"
              variant="contained"
              className={classes.action}
              disabled={!form.isValid || form.isSubmitting}
              isSubmitting={form.isSubmitting}
            />
          )}
        </DynamicForm>

        <Button color="primary" className={classes.secondBtn} onClick={navigateToForgetPassword}>
          Mot de passe oublié ?
        </Button>
        <div className={classes.info}>
          <Info
            title="Première connexion ? Welcome !"
            subtitle="Normalement, tu as reçu ton mot de passe sur ton adresse email ! Vérifie bien !"
          />
        </div>
        <Copyright />
      </Container>
    </div>
  );
};

export default Login;
